import React from 'react';
import './Inputs.css';

function Inputs({ inputs, onInputChange, onRandomize, onCopyURL }) {
  const handleChange = (name, value) => {
    const numValue = parseFloat(value) || 0;
    onInputChange(name, numValue);
  };

  const fieldDescriptions = {
    companySize: 'Total number of employees in the company',
    turnoverRate: 'Percentage of employees who leave the company annually',
    avgSalary: 'Average annual salary per employee in dollars',
    costPerHire: 'Total cost to hire a new employee, including recruitment, onboarding, and training',
    replaceTime: 'Average number of weeks it takes to fill a vacant position',
    absenteeism: 'Percentage of work time lost due to employee absences',
    revenuePerEmployee: 'Average annual revenue generated per employee',
    programCost: 'Total cost of the wellness or retention program being evaluated',
    retentionUplift: 'Expected percentage improvement in employee retention due to the program',
    timeToFillReduction: 'Expected percentage reduction in time-to-fill positions due to improved retention'
  };

  const LabelWithInfo = ({ htmlFor, children, description }) => (
    <label htmlFor={htmlFor} className="label-with-info">
      <span>{children}</span>
      <span className="info-icon" data-tooltip={description}>i</span>
    </label>
  );

  return (
    <div className="inputs">
      <h2 className="section-title">Inputs</h2>
      
      <div className="inputs-grid">
        <div className="input-group">
          <LabelWithInfo htmlFor="companySize" description={fieldDescriptions.companySize}>
            Company size
          </LabelWithInfo>
          <input
            id="companySize"
            type="number"
            value={inputs.companySize}
            onChange={(e) => handleChange('companySize', e.target.value)}
          />
        </div>

        <div className="input-group">
          <LabelWithInfo htmlFor="turnoverRate" description={fieldDescriptions.turnoverRate}>
            Turnover rate (%)
          </LabelWithInfo>
          <input
            id="turnoverRate"
            type="number"
            step="0.1"
            value={inputs.turnoverRate}
            onChange={(e) => handleChange('turnoverRate', e.target.value)}
          />
        </div>

        <div className="input-group">
          <LabelWithInfo htmlFor="avgSalary" description={fieldDescriptions.avgSalary}>
            Avg salary ($)
          </LabelWithInfo>
          <input
            id="avgSalary"
            type="number"
            value={inputs.avgSalary}
            onChange={(e) => handleChange('avgSalary', e.target.value)}
          />
        </div>

        <div className="input-group">
          <LabelWithInfo htmlFor="costPerHire" description={fieldDescriptions.costPerHire}>
            Cost per hire ($)
          </LabelWithInfo>
          <input
            id="costPerHire"
            type="number"
            value={inputs.costPerHire}
            onChange={(e) => handleChange('costPerHire', e.target.value)}
          />
        </div>

        <div className="input-group">
          <LabelWithInfo htmlFor="replaceTime" description={fieldDescriptions.replaceTime}>
            Replace time (weeks)
          </LabelWithInfo>
          <input
            id="replaceTime"
            type="number"
            value={inputs.replaceTime}
            onChange={(e) => handleChange('replaceTime', e.target.value)}
          />
        </div>

        <div className="input-group">
          <LabelWithInfo htmlFor="absenteeism" description={fieldDescriptions.absenteeism}>
            Absenteeism (%)
          </LabelWithInfo>
          <input
            id="absenteeism"
            type="number"
            step="0.1"
            value={inputs.absenteeism}
            onChange={(e) => handleChange('absenteeism', e.target.value)}
          />
        </div>

        <div className="input-group">
          <LabelWithInfo htmlFor="revenuePerEmployee" description={fieldDescriptions.revenuePerEmployee}>
            Revenue / employee ($)
          </LabelWithInfo>
          <input
            id="revenuePerEmployee"
            type="number"
            value={inputs.revenuePerEmployee}
            onChange={(e) => handleChange('revenuePerEmployee', e.target.value)}
          />
        </div>

        <div className="input-group">
          <LabelWithInfo htmlFor="programCost" description={fieldDescriptions.programCost}>
            Program cost ($)
          </LabelWithInfo>
          <input
            id="programCost"
            type="number"
            value={inputs.programCost}
            onChange={(e) => handleChange('programCost', e.target.value)}
          />
        </div>

        <div className="input-group">
          <LabelWithInfo htmlFor="retentionUplift" description={fieldDescriptions.retentionUplift}>
            Retention uplift (%)
          </LabelWithInfo>
          <input
            id="retentionUplift"
            type="number"
            step="0.1"
            value={inputs.retentionUplift}
            onChange={(e) => handleChange('retentionUplift', e.target.value)}
          />
        </div>

        <div className="input-group">
          <LabelWithInfo htmlFor="timeToFillReduction" description={fieldDescriptions.timeToFillReduction}>
            Time-to-fill ↓ (%)
          </LabelWithInfo>
          <input
            id="timeToFillReduction"
            type="number"
            step="0.1"
            value={inputs.timeToFillReduction}
            onChange={(e) => handleChange('timeToFillReduction', e.target.value)}
          />
        </div>
      </div>

      <div className="buttons-row">
        {/* <button className="btn btn-blue" onClick={onRandomize}>
          Randomize Demo
        </button> */}
        <button className="btn btn-green" onClick={onCopyURL}>
          Copy URL
        </button>
        <button className="btn btn-purple" onClick={() => window.open('https://calendar.app.google/uP134WqSSECYok8n6', '_blank')}>
          Book a Strategy Call
        </button>
      </div>

      {/* <p className="disclaimer">
        Demo only — values and formulas are illustrative. No data is stored.
      </p> */}
    </div>
  );
}

export default Inputs;


